import { AlignmentType, Paragraph, TextRun, WidthType } from "docx"


export const accrualPhasebullet1Audit = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Ping – sends an ICMP ECHO Request to a specific network host ",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics:false,
            bold:false
        })
    ]
})

export const accrualPhasebullet2Audit = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Telnet – attempts to establish an interactive telnet connection to a specific host system",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics:false,
            bold:false
        })
    ]
})

export const accrualPhasebullet3Audit = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "NMAP– Scanning for the port which is opened at the firewall/Server",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics:false,
            bold:false
        })
    ]
})

export const accrualPhasebullet4Audit = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Using port scanning utilities to identify any open ports or services (i.e., TCP 65,535 and UDP 65,535) on devices or servers reachable via Internal corporate network",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics:false,
            bold:false
        })
    ]
})

export const accrualPhasebullet5Audit = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Connecting to open ports using TCP or UDP network utilities to determine the type(s) of operating system(s), firewall application(s) and network service versions being used.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics:false,
            bold:false
        })
    ]
})

export const acclimatizePhaseTextAudit1 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "As information is gathered about the targets, cross-referencing with databases of known vulnerabilities and current and past attack methods are performed.",
            size: 24,
            font: "Arial",
            color: '000000',
            italics:false,
            bold:false
        }),
    ],
})

export const acclimatizePhaseTextAudit2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "After all open points have been assessed for internal connectivity and open services, an attempt will be made to determine if any weak configuration settings or parameters are in use/set for any internal system.",
            size: 24,
            font: "Arial",
            color: '000000',
            italics:false,
            bold:false
        }),
    ],
})

export const acclimatizePhaseTextAudit3 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Some of the specific steps we may execute include:",
            size: 24,
            font: "Arial",
            color: '000000',
            italics:false,
            bold:false
        }),
    ],
})

export const acclimatizebullet1Audit = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Using open source, commercial and proprietary vulnerability testing tools and techniques to identify specific vulnerabilities or exposure points (e.g., Remote management related vulnerabilities, SNMP/HTTP management vulnerabilities, etc.)",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics:false,
            bold:false
        })
    ]
})

export const acclimatizebullet2Audit = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Using comprehensive vulnerability scanning software to identify known problem areas.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics:false,
            bold:false
        })
    ]
})

export const acclimatizebullet3Audit = new Paragraph({
    indent: { left:600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Manual review conducted which included checking certain configuration files, checking auditing features that had been enabled or disabled, user and account policies etc.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics:false,
            bold:false
        })
    ]
})

export const admittancePhaseTextAudit = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "This phase was not performed as per the scope of the work.",
            size: 24,
            font: "Calibri",
            color: '000000',
            italics:false,
            bold:false
        }),
    ],
})

export const affirmationPhaseTextAudit = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "A detailed Assessment report is prepared and submitted to the client",
            size: 24,
            font: "Arial",
            color: '000000',
            italics:false,
            bold:false
        }),
    ],
})

export const methodologyAuditNote = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "** For this VA engagement, Phase-4 (Admittance phase) not considered/executed as per sow.",
            size: 16,
            font: "Arial",
            color: '000000',
            italics:true,
            bold:false
        }),
    ],
})
